export default {
    company: {
        alt: 'GPTW',
        tooltip: "This company is a 'Great Place To Work' certified company",
    },

    posting: {
        label: {
            alt: 'GPTW',
            tooltip: "This post belongs to a 'Great Place To Work' company",
        },

        detail: {
            alt: 'GPTW',
            tooltip: {
                isCertified: '{companyName} is a certified Great Place To Work',
                description:
                    'Lorem ipsum dolor sit amet, conextetur adipiscing elit. Sed fingilla pretium nunv, non vestibulum tellus imperdiet sed.',
                readMore: 'Click to read more',
            },
        },
    },
};
